/**
 * Web analytics event katalogu.
 * Tracker collector'lari, SDK komutlari ve customer-panel dokumantasyonu ayni listeyi kullanir.
 * Panel kopyasi: customer-panel/src/views/Pages/Integrations/WebAnalytics/webAnalyticsCatalog.js
 */

// A. Otomatik toplanan event'ler (SDK kendiliginden uretir)
export const AUTO_EVENTS = {
    SESSION_START: "session_start",
    PAGE_VIEW: "page_view",
    PAGE_LEAVE: "page_leave",
    CLICK: "click",
    OUTBOUND_CLICK: "outbound_click",
    SITE_SEARCH: "site_search",
    FORM_START: "form_start",
    FORM_SUBMIT: "form_submit",
    FORM_ERROR: "form_error",
    FILE_DOWNLOAD: "file_download",
    VIDEO_START: "video_start",
    VIDEO_PROGRESS: "video_progress",
    VIDEO_COMPLETE: "video_complete",
    ELEMENT_VIEWED: "element_viewed",
    RAGE_CLICK: "rage_click",
    DEAD_CLICK: "dead_click",
    JS_ERROR: "js_error",
    WEB_VITALS: "web_vitals",
    COPY: "copy",
};

// B. Kimlik ve yasam dongusu
export const IDENTITY_EVENTS = {
    IDENTIFY: "identify",
    ALIAS: "alias",
    GROUP: "group",
    SIGN_UP: "sign_up",
    LOGIN: "login",
    LOGOUT: "logout",
    CONSENT_UPDATED: "consent_updated",
    RESET: "reset",
};

// C. E-ticaret (Segment E-commerce spec)
export const ECOMMERCE_EVENTS = [
    // Kesif
    "products_searched",
    "product_list_viewed",
    "product_list_filtered",
    "product_clicked",
    "product_viewed",
    "promotion_viewed",
    "promotion_clicked",
    // Sepet
    "product_added",
    "product_removed",
    "cart_viewed",
    // Odeme
    "checkout_started",
    "checkout_step_viewed",
    "checkout_step_completed",
    "payment_info_entered",
    "order_completed",
    "order_updated",
    "order_refunded",
    "order_cancelled",
    // Kupon
    "coupon_entered",
    "coupon_applied",
    "coupon_denied",
    "coupon_removed",
    // Liste / paylasim
    "product_added_to_wishlist",
    "product_removed_from_wishlist",
    "product_shared",
    "product_reviewed",
];

// D. Kampanya dongusu
export const CAMPAIGN_EVENTS = [
    "campaign_shown",
    "campaign_clicked",
    "campaign_dismissed",
    "campaign_converted",
    "experiment_viewed",
    "recommendation_shown",
    "recommendation_clicked",
];

// E. Supsis'e ozel event'ler. Buradaki iki tanesi widget tarafinda bilinir,
// kalani backend tarafindan uretilir (bkz. tablet/services/webAnalytics/publishServerEvent.js).
export const WIDGET_EVENTS = {
    CHAT_WIDGET_OPENED: "chat_widget_opened",
    PROACTIVE_TRIGGER_SHOWN: "proactive_trigger_shown",
    PROACTIVE_TRIGGER_ACCEPTED: "proactive_trigger_accepted",
};

// Event kategorileri; sunucu tarafinda WebEvent.category alanina yazilir.
export const CATEGORIES = {
    AUTO: "auto",
    IDENTITY: "identity",
    ECOMMERCE: "ecommerce",
    CAMPAIGN: "campaign",
    SUPSIS: "supsis",
    CUSTOM: "custom",
};

const AUTO_EVENT_NAMES = Object.keys(AUTO_EVENTS).map(function (key) {
    return AUTO_EVENTS[key];
});
const IDENTITY_EVENT_NAMES = Object.keys(IDENTITY_EVENTS).map(function (key) {
    return IDENTITY_EVENTS[key];
});
const WIDGET_EVENT_NAMES = Object.keys(WIDGET_EVENTS).map(function (key) {
    return WIDGET_EVENTS[key];
});

/** Event ismini snake_case'e normalize eder, 64 karakterle sinirlar. */
export function normalizeEventName(name) {
    if (!name || typeof name !== "string") return "";
    return name
        .trim()
        .toLowerCase()
        .replace(/[\s\-.]+/g, "_")
        .replace(/[^a-z0-9_]/g, "")
        .slice(0, 64);
}

/** Event isminden kategori cozer; bilinmeyen isimler custom sayilir. */
export function resolveCategory(name) {
    const normalized = normalizeEventName(name);
    if (AUTO_EVENT_NAMES.indexOf(normalized) !== -1) return CATEGORIES.AUTO;
    if (IDENTITY_EVENT_NAMES.indexOf(normalized) !== -1) return CATEGORIES.IDENTITY;
    if (ECOMMERCE_EVENTS.indexOf(normalized) !== -1) return CATEGORIES.ECOMMERCE;
    if (CAMPAIGN_EVENTS.indexOf(normalized) !== -1) return CATEGORIES.CAMPAIGN;
    if (WIDGET_EVENT_NAMES.indexOf(normalized) !== -1) return CATEGORIES.SUPSIS;
    return CATEGORIES.CUSTOM;
}

export function isEcommerceEvent(name) {
    return ECOMMERCE_EVENTS.indexOf(normalizeEventName(name)) !== -1;
}

/**
 * Rezerve property isimleri. Sunucu bunlari WebEvent'in ust seviye alanlarina
 * normalize eder; gelir ve katalog raporlarinin otomatik calismasi buna bagli.
 */
export const RESERVED_PROPS = [
    "product_id",
    "sku",
    "name",
    "category",
    "brand",
    "variant",
    "price",
    "currency",
    "quantity",
    "position",
    "list_id",
    "coupon",
    "discount",
    "revenue",
    "tax",
    "shipping",
    "order_id",
    "query",
    "results_count",
];

// Autocapture ayar anahtarlari. Varsayilan degerler tablet/models/Setting.js
// icindeki webAnalytics.autocapture ile ayni olmali.
export const AUTOCAPTURE_DEFAULTS = {
    outboundClick: true,
    siteSearch: true,
    forms: true,
    fileDownload: true,
    rageClick: true,
    click: false,
    deadClick: false,
    video: false,
    elementViewed: false,
    jsError: false,
    webVitals: false,
    copy: false,
};



//////////////////
// WEBPACK FOOTER
// ./static/src/tracker/events.js
// module id = 59yW
// module chunks = 1 2